/** Umbrella experiment that gates whether the editor VSM engine is available. */
export const VSM_EDITOR_EXPERIMENT = 'specs.thunderbolt.vsm_editor' as const

/** Shared experiment that converts every registered editor feature from Carmi to VSM. */
export const VSM_EDITOR_CONFIGS_EXPERIMENT = 'specs.thunderbolt.vsmEditorConfigs' as const

/**
 * Editor VSM platform surface (ADR-0007): the `*WixCodeSdk` editor configs — the platform worker
 * bootstrap's inputs, read from Carmi's `siteFeaturesConfigs` aggregate — and, with TB-15447, the platform
 * module itself convert under this spec instead of `VSM_EDITOR_CONFIGS_EXPERIMENT`, so the worker's inputs
 * flip together with their producer. Must stay closed until TB-15447 lands.
 */
export const VSM_EDITOR_PLATFORM_EXPERIMENT = 'specs.thunderbolt.vsmEditorPlatform' as const
